import { render, staticRenderFns } from "./JointProduct.vue?vue&type=template&id=7fb5aaf4&"
import script from "./JointProduct.vue?vue&type=script&lang=js&"
export * from "./JointProduct.vue?vue&type=script&lang=js&"
import style0 from "./JointProduct.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports